import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';

import { modelosContaContabil, contasContabeisModuleName } from "../shared/data.service";

@Component({
  selector: 'conta-contabil-table',
  template: require('./conta-contabil-table.component.html'),
  styles: [require('./conta-contabil-table.component.css')]
})

export class ContaContabilTableComponent implements OnInit {
  @Output() editEvent: EventEmitter<any> = new EventEmitter();
  @Output() deleteEvent: EventEmitter<any> = new EventEmitter();
  @Input() list: any = [];
  @Input() listFilter: any;
  @Input() showDisabled: boolean;
  @Input() count: number;

  types: any = modelosContaContabil;
  contasContabeisModuleName: string = contasContabeisModuleName;

  constructor() {}

  ngOnInit() {
    this.count += 1;
  }

  clickEdit(item: any) {
    this.editEvent.next(item);
  }

  clickDelete(item: any) {
    this.deleteEvent.next(item);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/contas/conta-contabil/conta-contabil-table/conta-contabil-table.component.ts
 **/